"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";
import { withLang } from "@/lib/i18n";

interface TrackFormProps {
  locale: "en-US" | "pt-PT";
  defaultCode?: string;
  defaultEmail?: string;
}

export function TrackForm({ locale, defaultCode, defaultEmail }: TrackFormProps) {
  const router = useRouter();
  const [code, setCode] = useState(defaultCode ?? "");
  const [email, setEmail] = useState(defaultEmail ?? "");

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!code.trim() || !email.trim()) return;
    const url = `/track?code=${encodeURIComponent(code.trim())}&email=${encodeURIComponent(email.trim().toLowerCase())}`;
    router.push(withLang(url, locale));
  }

  const labels = {
    codePlaceholder: locale === "pt-PT" ? "Código de encomenda (ex: ORD-...)" : "Order code (e.g. ORD-...)",
    emailPlaceholder: locale === "pt-PT" ? "Email utilizado na compra" : "Email used at checkout",
    submit: locale === "pt-PT" ? "Ver encomenda" : "Track order",
  };

  const inputCls =
    "w-full border-b border-[#D9D1C6] bg-transparent py-3 text-sm text-[#2B2824] placeholder:text-[#C0B8AD] transition-colors focus:border-[#2B2824] focus:outline-none";

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-6 sm:flex-row sm:items-end sm:gap-0 border-b border-[#D9D1C6]">
      <div className="flex-1 sm:border-r sm:border-[#D9D1C6] sm:pr-6">
        <input
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          placeholder={labels.codePlaceholder}
          required
          className={inputCls}
        />
      </div>
      <div className="flex-1 sm:px-6">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={labels.emailPlaceholder}
          required
          className={inputCls}
        />
      </div>
      <button
        type="submit"
        className="shrink-0 bg-[#4F4A43] px-7 py-3.5 text-[10px] font-semibold tracking-[0.22em] text-[#F8F6F1] uppercase transition hover:bg-[#2B2824]"
      >
        {labels.submit}
      </button>
    </form>
  );
}
